import React from "react";
import "./PlatformStatusBadge.css";

/**
 * A-009A — Renders payload status/badge only. No business rules.
 */
function PlatformStatusBadge({ status, badge, statusKey }) {
  const label = badge || status || "";
  if (!label) return null;
  const key = (statusKey || "").replace(/_/g, "-") || "planned";

  return (
    <span className={`platform-status-badge platform-status-badge--${key}`}>
      {label}
    </span>
  );
}

export default PlatformStatusBadge;
